<template>
    <div v-if="context.incident">
        <div class="v-flex">
            <!-- add unit selection -->
            <div class="add-unit-selection">
                <v-menu
                    v-model="showSelection"
                    :close-on-content-click = "false"
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <v-icon class="toolbar-button-ripple" size="22" color="white">mdi-plus</v-icon>
                        </div>
                    </template>

                    <c-site-selection
                        :customer        = "customer"
                        :force-all-units = "isModernization"
                        @cut             = "onAdd"
                    />
                </v-menu>
            </div>
            <!-- add unit selection -->

            <!-- prev site button -->
            <div v-if="sites && sites.length > 1" style="margin-top: -2px;" class="mr-1">
                <c-toolbar-button
                    :icon="index === 0 ? 'mdi-arrow-left-drop-circle-outline' : 'mdi-arrow-left-drop-circle'"
                    color="white"
                    size="24"
                    tooltip="Vorheige Anlage"
                    @click = "onPrev"
                />
            </div>
            <!-- prev site button -->

            <p-inc-navigation-menu
                :step-units = "stepUnits"
                :step       = "step"
                @select     = "onSelect"
                @remove     = "onRemove"
            />

            <!-- next site button -->
            <div v-if="sites && sites.length > 1" style="margin-top: -2px;" class="ml-0">
                <c-toolbar-button
                    :icon="index >= stepUnits.length-1 ? 'mdi-arrow-right-drop-circle-outline' : 'mdi-arrow-right-drop-circle'"
                    color="white"
                    size="24"
                    tooltip="Nächste Anlage"
                    @click = "onNext"
                />
            </div>
            <!-- next site button -->
        </div>
    </div>
</template>

<script>

import CSiteSelection     from "@/modules/msd/unit/components/controlls/CSiteSelection.vue";
import CToolbarButton     from "@/modules/core/components/utils/CToolbarButton.vue";
import PIncNavigationMenu from "@/modules/inc/steps/components/navigation/private/PIncNavigationMenu.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "CIncNavigation",

    components: {
        PIncNavigationMenu,
        CToolbarButton,
        CSiteSelection,
    },

    data: () => ({
        showSelection: false,
        size         : 18,
        step         : 0,
        stepUnits    : []
    }),

    computed: {
        incident () {
            return this.$store.getters.incident;
        },

        sites () {
            return this.incident.sites;
        },

        customer () {
            if (!this.sites || this.sites.length === 0) {
                return null;
            }

            return this.sites[0].customer;
        },

        context () {
            return this.$store.getters.context;
        },

        selected () {
            return this.context.site;
        },

        index () {
            return this.stepUnits.findIndex (u => u.id === this.selected);
        },

        isModernization () {
            return Inc.isModernization(this.incident);
        },
    },

    created() {
        this.$bus.$on(this.$incident.events.context.stepChanged, this.onStepChanged);
        this.$bus.$on(this.$incident.events.context.entered,     this.onContextEntered);
    },

    beforeDestroy() {
        this.$bus.$off(this.$incident.events.context.stepChanged, this.onStepChanged);
        this.$bus.$off(this.$incident.events.context.entered,     this.onContextEntered);
    },

    mounted() {
        this.onContextEntered({
            index: 0
        })
    },

    methods: {
        onSelect (unit) {
            const context = this.$store.getters.context;
            this.$bus.$emit(this.$incident.events.context.leave,() => {
                context.site = unit.id;
                this.$store.dispatch("setContext", context).then (() => {
                    this.$bus.$emit(this.$incident.events.context.entered, {
                        unit : unit,
                        index: this.step,
                    });
                });
            });
        },

        onAdd (unit) {
            this.showSelection = false
            console.log(unit)
        },

        onRemove (unit) {
            this.$bus.$emit(this.$incident.events.unit.remove, unit);
        },

        onNext () {
            this.$nextTick(() => {
                const index = this.index;
                if (index < this.stepUnits.length - 1) {
                    this.onSelect(this.stepUnits[index+1]);
                }
            })
        },

        onPrev () {
            const index = this.index;
            if (index > 0) {
                this.onSelect(this.stepUnits[index-1]);
            }
        },

        onContextEntered (context) {
            if (!this.incident) {
                return;
            }

            if (!this.stepUnits) {
                this.stepUnits = this.sites;
                this.step = context.index;
                return;
            }

            const data = this.incident.data[context.index]
            const units = [];

            data.collection.forEach(entry => {
                units.push(entry.unit)
            });

            units.sort((l, r) => l.fabricNo.localeCompare(r.fabricNo));
            this.stepUnits = units;
            this.step = context.index;
        },

        onStepChanged (index) {
            this.step = index;
            this.onContextEntered({
                index: index
            })
        },
    }
}
</script>

<style scoped>

.add-unit-selection {
    margin-top: -4px;
    max-height: 20px;
}

</style>